import { Component } from 'react';
import { debounceTime } from 'rxjs/operators';
import ContactUsModal from '../../components/ui/contact-us-modal/contact-us.modal';
import { FileListComponent } from '../../components/ui/file-list/file-list.component';
import { MotiveComponent } from '../../components/ui/motive/motive.component';
import { IOC_TYPES } from '../../context/ioc.types';
import { lazyInject } from '../../context/module';
import { FileUpload } from '../../models/file-upload';
import { FileManagerService } from '../../services/file-manager.service';
import { LoginService } from '../../services/login.service';
import { MotivesService } from '../../services/motives.service';
import { WindowService } from '../../services/window.service';
import { PSDate } from '../../utils/date.utils';
import { MotiveConfig, MotiveLocationTypes } from '../../utils/request.utils';
import { untilDestroyed } from '../../utils/until-destroyed';
import styles from './file-download.component.module.scss';

export default class FileDownloadComponent extends Component<any> {
    public fileArray: FileUpload[] = [];
    /// This prevent SEO CLS jump
    private fileArrayCalculated = false;

    public recoveredFileUploads: FileUpload[] = [];
    public activeFileUploads: FileUpload[] = [];
    motives: MotiveConfig;

    public showHelpUsMessage = true;
    private isFreeUser = true;
    public internalAdsEnabled = false;
    public hasFiles = false;

    @lazyInject(IOC_TYPES.FileManagerService) private fileManagerService: FileManagerService;
    @lazyInject(IOC_TYPES.WindowService) public windowService: WindowService;
    @lazyInject(IOC_TYPES.MotivesService) public motivesService: MotivesService;
    @lazyInject(IOC_TYPES.LoginService) public loginService: LoginService;

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.loginService.onSessionDetails
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (details) => {
                    this.isFreeUser = !details.isPaidUser;
                }
            });

        this.motivesService.onEffectiveMotiveSettingsChange
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (motives) => {
                    this.showHelpUsMessage = this.isFreeUser && motives.headerPromotionToBuy;
                    this.internalAdsEnabled = this.motives && this.motives.internalMotivesEnabled;
                },
                error: (error) => console.error(error),
            });

        this.fileManagerService.fileUploadsListChanged
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (fileUploads) => {
                    this.updateFileArrayForDisplay(fileUploads);
                },
            });

        this.fileManagerService.fileUploadChanged.pipe(
            untilDestroyed(this),
            debounceTime(100)
        ).subscribe({
            next: (fileUpload) => {
                this.forceUpdate();
            }
        })
    }

    componentWillUnmount() {
        // for untilDestroyed
    }

    updateFileArrayForDisplay(fileUploads: FileUpload[]) {
        this.fileArray = [];
        fileUploads.forEach(fileUpload => {
            this.fileArray.push(fileUpload);
        });
        this.fileArray = this.fileArray.sort((a, b) =>
            PSDate.from(a.processStartTime).isBefore(b.processStartTime) ? 1 : -1);
        this.activeFileUploads = this.fileArray.filter(f => !f.recoveredFileUpload);
        this.recoveredFileUploads = this.fileArray.filter(f => f.recoveredFileUpload);
        this.hasFiles = !!(this.recoveredFileUploads.length || this.activeFileUploads.length);
        this.fileArrayCalculated = true;
        this.forceUpdate();
    }

    showContactUs(e: MouseEvent) {
        e.preventDefault();
        ContactUsModal.show({});
    }

    getFileLists(props) {
        return <div>
            <div>
                <FileListComponent {...props} sectionTitle="Downloadable Files" fileUploadArray={this.fileArray}
                    parentClasses="" cardClasses="">
                    {
                        <div className="gcontent-container">
                            <MotiveComponent
                                data="5731283493" containerWidth="100%" containerHeight="60px"
                                location={MotiveLocationTypes.fileDownloadPageWithInCurrentDownloads} adWidth="720px" adHeight="60px"
                                showAds={true} className='width_major_md'
                            ></MotiveComponent>
                        </div>
                    }

                </FileListComponent>
            </div>
        </div>;
    }

    render() {
        if (!this.fileArrayCalculated) {
            return <div style={{ minHeight: '1000px' }}></div>;
        }
        return <div style={{ minHeight: '1000px' }}>
            <div>
                {
                    <div className="gcontent-container">
                        <MotiveComponent
                            data="4411354276" containerWidth="100%" containerHeight="90px"
                            location={MotiveLocationTypes.fileDownloadPageTop} adWidth="970px" adHeight="90px" showAds={true} className='width_major'
                        ></MotiveComponent>
                    </div>
                }
            </div>

            {
                this.showHelpUsMessage && <div className={`p-2 mt-3 mb-3 ${styles['help-message']}`}>
                    Like our service? Please <a href="/how-to-help-xconvert-to-grow">help us grow XConvert
                    </a>
                </div>
            }

                <div className='row'>
                <div className='col-md-2 d-none d-md-block'>
                {
                    <div className="gcontent-container">
                        <MotiveComponent
                            data="4411354276" containerWidth="100%" containerHeight="600px"
                            location={MotiveLocationTypes.fileDownloadPageLeft} adWidth="160px" adHeight="600px" showAds={true} className='height_major'
                        ></MotiveComponent>
                    </div>
                }
                </div>
                    <div className="col-12 col-md-8">
                        {
                            this.getFileLists(this.props)
                        }
                        <div>
                            <div>
                                {
                                    !this.hasFiles && <p className="text-danger">You don't have any downloadable files. You will see
                                        your processed files
                                        or in progress files from current and previous sessions here.</p>
                                }

                                <h5 className="mt-3">About <b>My Downloads</b> page</h5>
                                <p>This page will show you all the in progress and processed files in File Cards as shown on
                                    Image 1
                                    and 2 (below). In progress files are files
                                    that XConvert is still processing and processed files are files that are completed. Progress
                                    bar with percentage completed will be shown on File Cards for in progress files.
                                    At the footer of each card contains some useful buttons which allows you to perform actions
                                    like download file.</p>

                            </div>
                            <div>
                                <h5>More About File Cards</h5>
                            </div>
                            <div></div>
                            <div>
                                <div className={styles['card']} style={{ width: '100%', textAlign: 'center', height: '210px' }}>
                                    <img className={styles['card-img-top']} src="/img/completed-file.png" style={{ width: '200px', height: '150px' }}
                                        alt="Completed file example" />
                                    <div className="card-body">
                                        <p className="card-text">Image 2 - Completed file example</p>
                                    </div>
                                </div>
                            </div>
                            <div></div>
                            <div>
                                <h5 className="mt-1">File Card footer buttons explanation</h5>
                                <ol>
                                    <li>
                                        <b>Download</b> button: This button will be enabled once XConvert completed your request
                                        to convert or compress a file. If you converted a PDF to JPG, clicking on this button
                                        will open up a Modal. You can use the download button on that modal to download
                                        individual image. If you compressed a file like a video, you can download that file by
                                        clicking on the Download button.
                                    </li>
                                    <li>
                                        <b>Check Status</b> button: This button allows you to manually check file progress
                                        status. IF for some reason file progress bar get stuck, you may use this button to
                                        manually trigger the status update.
                                    </li>
                                    <li>
                                        <b>Re-edit</b> button: This convenient feature lets you convert/compress/etc... the same
                                        file without uploading it. Press on it to display all the available options that you saw
                                        on file upload page.
                                    </li>
                                    <li>
                                        <b>Play</b> button: This button will show up if the output file is of type video, image
                                        or pdf. For image and pdf, icon will be a eye, instead of play button. You can click on
                                        this to view the actual file on the browser.
                                    </li>
                                    <li>
                                        <b>Delete</b> button: You can delete your files by clicking on Trash Can icon. This will
                                        delete the file from remote server and your local storage.
                                    </li>
                                </ol>
                            </div>

                            <div>
                                <h5 className="mt-1">FAQ</h5>
                                <ol>
                                    <li>
                                        <b>Why my file download take so long?</b>
                                        <p>If you are located far away from the server that
                                            processed your file, then the network connectivity between you and the server could
                                            be really slow. There is nothing much we can do about it.</p>
                                    </li>

                                    <li>
                                        <b>Why my compressed file are sometimes bigger?</b>
                                        <p>It is impossible to tell exact output
                                            size before compressing a file. Sometime depending on the configuration, XConvert
                                            might produces larger output files. You can always use <b>Re-edit</b> button to
                                            retry it
                                            again with different set of options.</p>
                                    </li>

                                    <li>
                                        <b>Does any one have access to my uploaded files?</b>
                                        No, we only keep your file on our servers for maximum of 4-6 hours. All files are
                                        completely deleted from servers after that timeframe. You can manually delete your file
                                        clicking on the trash can icon on the File Card.
                                    </li>

                                    <li>
                                        <b>Can I leave the page or close the browser after pressing Compress/Convert button?</b>
                                        Yes. Once you start a process, we will keep track of your file and display it on My
                                        Downloads page until we delete them from the server. If you return to the My Download
                                        page with-in 4 hours of starting the file process, you will be able to access and
                                        download those files.
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>

                <div className='col-md-2 d-none d-md-block'>
                {
                    <div className="gcontent-container">
                        <MotiveComponent
                            data="4411354276" containerWidth="100%" containerHeight="600px"
                            location={MotiveLocationTypes.fileDownloadPageRight} adWidth="160px" adHeight="600px" showAds={true} className='height_major'
                        ></MotiveComponent>
                    </div>
                }
                </div>
            </div>

            <div>
                <div>
                    <div>
                        {
                            <div className="gcontent-container">
                                <MotiveComponent
                                    data="5895347409" containerWidth="100%" containerHeight="90px"
                                    location={MotiveLocationTypes.fileDownloadPageBottom} adWidth="970px" adHeight="90px" showAds={true}
                                    className='width_major'
                                    ></MotiveComponent>
                            </div>
                        }

                    </div>
                </div>
            </div>


        </div>
    }
}
